module.exports = __webpack_public_path__ + "media/images/abstract-art-blur-bright-4bfafbae50c65dfc0b18a8d9e44d606f3ceab021b7eda256766a772088d93556.jpg";